export const getTodayDay = () => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]
  const d = new Date()
  return days[d.getDay()]
}



// WEBPACK FOOTER //
// ./assets/common/components/RecommendationCard/common.js